<template>
  <div class="route-poi-list__container">
    <h4
      v-if="props.poiInformation"
      class="mt-1"
    >
      {{ props.poiInformation }}
    </h4>
    <div
      v-for="(item, key) in props.poiList"
      :key="key"
      class="route-poi-list__item-info-container"
    >
      <span class="route-poi-list__item-info-name">{{ item.name }}</span>
      <Button
        v-tooltip="'Mostrar en mapa'"
        class="mc-row__button p-button-secondary"
        rounded
        raised
        @click="goCoordinates(item)"
      >
        <span class="material-icons">arrow_circle_right</span>
      </Button>
    </div>
  </div>
</template>

<script setup>
import Button from 'primevue/button';
// #region Props, Emits
const props = defineProps({
  poiInformation: {
    type: String,
    default: () => '',
  },
  poiList: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['goCoordinates']);
// #endregion

// #region Params, Ref, Reactives, Computed
// #endregion

// #region Functions
async function goCoordinates({coordinates, name}) {
  const zoom = 10;
  const visible = false;
  emit('goCoordinates', {coordinates, name, visible, zoom});
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.route-poi-list__container {
  & .route-poi-list__item-info {
    &-container {
      display: flex;
      margin: 0.6rem 0.2rem;
      justify-content: left;
      align-items: center;
    }
    &-name {
      display: block;
      padding: 0.2rem 0.4rem 0.2rem 0;
    }
    &-go-button {
      width: 1rem;
      height: 1rem;
      cursor: pointer;
      padding: 0;
    }
  }
}
</style>
